var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitucional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 12H0.333252V10.6667H0.999919V0.666667C0.999919 0.489856 1.07016 0.320286 1.19518 0.195262C1.32021 0.0702379 1.48977 0 1.66659 0H10.9999C11.1767 0 11.3463 0.0702379 11.4713 0.195262C11.5963 0.320286 11.6666 0.489856 11.6666 0.666667V4H12.9999V10.6667H13.6666V12ZM10.3333 10.6667H11.6666V5.33333H7.66659V10.6667H8.99992V6.66667H10.3333V10.6667ZM10.3333 4V1.33333H2.33325V10.6667H6.33325V4H10.3333ZM3.66659 5.33333H4.99992V6.66667H3.66659V5.33333ZM3.66659 8H4.99992V9.33333H3.66659V8ZM3.66659 2.66667H4.99992V4H3.66659V2.66667Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitucional);
export default __webpack_public_path__ + "static/media/Institucional.a1086568376650232d92d6ba0be206fb.svg";
export { ForwardRef as ReactComponent };